<template>
  <div>
    <div id="chartDivLP"/>
    <div v-if="!dataHasAtLeastOneDataValue">
      <p class="noData">No data to display in chart</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import isNumber from 'is-number';
import _ from 'lodash';
import makeChart from './chart';

function hasAtLeastOneDataValue(lpData) {
  const firstRowWithDataValue = _(lpData).find(row => isNumber(row.dv));
  return firstRowWithDataValue !== undefined;
}

const overallStratCatId = 'CAT1';
export default {
  computed: {
    ...mapState({
      lku: state => state.lku,
      lpData: state => state.LP.lpData,
      stratFilters: state => state.LP.stratFilters,
      dataTypes: state => state.dataTypes,
    }),
    ...mapGetters([
      // 'dataValueUnit',
      // 'decimalPlaces',
      // 'confidenceIntervalLabel',
    ]),
    dataHasAtLeastOneDataValue() {
      return hasAtLeastOneDataValue(this.lpData);
    },
    // chartConfigObject() {
    //   return {
    //     xAxisColumn: this.xAxisColumn,
    //     xAxisType: this.xAxisType,
    //     legendColumn: this.legendColumn,
    //     legendType: this.legendType,
    //     legendTitleStr: this.legendTitle,
    //     displayTrendChart: this.displayTrendChart,
    //     chartDivLPId: 'chartDivLP',
    //     colorsArrStr: ['#FFFF99', '#FDBF6F', '#FF7F00', '#CAB2D6', '#f781bf', '#a65628', '#ff7f00', '#984ea3', '#4daf4a', '#e41a1c', '#377eb8'].reverse(),
    //     yAxisTitle: this.dataTypesProperties('chartAxisLabel'),
    //     decimalPlaces: this.dataTypesProperties('decimalPlaces'),
    //     confidenceIntervalLabel: this.dataTypesProperties('ciRowLabel'),
    //     sampleSizeLabel: this.dataTypesProperties('sampleSizeLabel'),
    //     dataValuePrefix: this.dataTypesProperties('dataValuePrefix'),
    //     dataValueSuffix: this.dataTypesProperties('dataValueSuffix'),
    //     chartTitle508: 'chart 508 title goes here',
    //     chartDesc508: 'chart 508 desc goes here',
    //   };
    // },
    dataValueType() {
      const row = this.lku.DataValueType[this.stratFilters.dataValueTypeId];
      const name = row ? row.name : '';
      return `${name} %`;
    },
    getCompareColumn() {
      if (this.stratFilters.legendColumn === '') {
        return 'Overall';
      }
      return this.stratFilters.legendColumn;
    },
    getCompareStr() {
      return this.stratFilters.legendType;
    },
    legendTitle() {
      if (this.stratFilters.legendColumn === 'rs') return 'Responses';
      if (this.stratFilters.legendColumn === 's1'
         && this.stratFilters.stratCatId1 === overallStratCatId) return '';
      const legendTitleColumn = this.stratFilters.legendColumn === 's1' ? 'sc1' : 'sc2';
      return this.lku.StratificationCategory[this.lpData[0][legendTitleColumn]].name;
    },
    confidenceIntervalLabel() {
      return this.stratFilters.dataValueTypeId ? this.dataTypes[this.stratFilters.dataValueTypeId].confidenceIntervalLabel : '';
    },
    decimalPlaces() {
      return 1;
    },
  },
  watch: {
    lpData() {
      this.makeChart();
    },
  },
  mounted() {
    this.makeChart();
  },
  methods: {
    makeChart() {
      if (this.dataHasAtLeastOneDataValue) {
        // const groupMapping = {
        //   Overall: 'Overall',
        //   YEAR: 'Year',
        //   RESPONSE: 'Response',
        //   AGE: 'AgeGroup',
        //   GENDER: 'Gender',
        //   RACE: 'RaceEthnicity',
        //   RiskFactorResponse: 'RiskFactorResponse',
        // };
        // const groupColumnMapping = {
        //   Overall: '',
        //   YEAR: 'yr',
        //   RESPONSE: 'rs',
        //   AGE: 'ag',
        //   GENDER: 'ge',
        //   RACE: 're',
        //   RiskFactorResponse: 'rfr',
        // };
        // let compareIdFix = this.compareId;
        // if (compareIdFix === '') {
        //   compareIdFix = 'Overall';
        // } else if (compareIdFix.substring(0, 2) === 'RF') {
        //   compareIdFix = 'RiskFactorResponse';
        // }
        // const compareStr = groupMapping[compareIdFix];
        const compareStr = this.getCompareStr;
        const settingsObj = {
          colorsArrStr: ['#1f78b4', '#e31a1c', '#33a02c', '#6a3d9a', '#ff7f00', '#b15928', '#a6cee3', '#fb9a99', '#b2df8a', '#cab2d6', '#fdbf6f', '#ffff99'],

          chartTitleStr: this.dataValueType,
          // dataCompareColumn: groupColumnMapping[compareIdFix],
          dataCompareColumn: this.getCompareColumn,
          // legendTitleStr: this.compare,
          legendTitleStr: this.legendTitle,
          decimalPlaces: this.decimalPlaces,
          confidenceIntervalLabel: this.confidenceIntervalLabel,
          chartSummary: this.$store.getters['LP/chartSummary'],
        };
          // use slice to pass a copy of the lpData array to prevent
          // the makeChart function from mutating the original array
          // which causes vuex errors: Error: [vuex] Do not mutate vuex store state outside mutation handlers.
        makeChart(this.lpData.slice(), this.lku, compareStr, settingsObj, 'chartDivLP');
      } else {
        document.getElementById('chartDivLP').innerHTML = '';
      }
    },
  },
};

</script>


<style>
  div#chartDivLP {
    max-width: auto;
    margin: 40px 15px 10px 15px;
  }

  div#chartDivLP h4 {
    margin: 0 auto;
    padding-top: 15px;
    padding-bottom: 15px;

  }


  /* div#chartDivLP {
    max-width: 1100px;
  } */

  div#chartDivLP svg {
    overflow: hidden;
  }

  div#barTooltip {
    position: absolute;
    max-width: 250px;
    height: auto;
    padding: 10px;
    background-color: #EEE;
    border-radius: 2px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.45);
    pointer-events: none;
    font-size: 14px;
    line-height: 150%;
  }

  div#legend {
    font-size: 12px;
    padding: 6px;
    float: right;
    margin-right: 20px;
    box-sizing: border-box;
  }

  div.legendLine {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
  }

  div#legendTitle {
    padding-bottom: 3px;
    font-weight: bold;
    font-size: 14px;
  }

  div.legendLine>.legendSquare {
    width: 10%;
    float: left;
    box-sizing: border-box;
    padding-top: 1px;
  }

  div.legendLine>.legendSquareText {
    width: 90%;
    float: left;
    box-sizing: border-box;
    font-size: 14px;
  }

  .noData {
    text-align: center;
    font-weight: bold;
  }
  .customBar{
    opacity: 0.5;
  }
  .headerRow {
    background-color: #C1DED5 !important;
  }

  div#chartDivLP h4 {
    font-size: large;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/ChartView.vue